import { createStore, useStore } from 'zustand';

import { logger } from '@lib/logger';
import { lookupsStore } from '@stores/lookups';
import { fetchBranchMenus, fetchMenuDetailsApi } from '@lib/api';

import { MenusStateStore } from './types';
import { fromBranchMenusResponseToMenus } from './utils/fromBranchMenusResponseToMenus';
import { fromMenuResponseToMenuDetails } from './utils/fromMenuResponseToMenuDetails';

export const menusStore = createStore<MenusStateStore>((set) => ({
  branch: null,
  menus: [],
  selectedMenu: null,
  error: null,
  loading: false,
  menuLoading: false,
  fetch: async (branch) => {
    try {
      set({ loading: true, selectedMenu: null });
      const response = await fetchBranchMenus(branch.branchUUID);
      const menus = fromBranchMenusResponseToMenus(response);

      const menuResponse = await fetchMenuDetailsApi(
        branch.branchUUID,
        menus[0].uuid,
      );

      const selectedMenu = await fromMenuResponseToMenuDetails(
        menuResponse,
        menus[0].uuid,
      );

      set({ menus, branch, selectedMenu });
    } catch (error) {
      logger.error(error);
      set({ error });
    } finally {
      set({ loading: false });
    }
  },
  fetchMenuDetails: async (branchUUID, menuUUID) => {
    try {
      set({ menuLoading: true, selectedMenu: null });
      const menuResponse = await fetchMenuDetailsApi(branchUUID, menuUUID);
      const selectedMenu = await fromMenuResponseToMenuDetails(
        menuResponse,
        menuUUID,
      );

      set({ selectedMenu });
    } catch (error) {
      logger.error(error);
      set({ error });
    } finally {
      set({ menuLoading: false });
    }
  },
  updateSelectedMenu: async (itemUUID, availability) => {
    menusStore.getState().selectedMenu?.categories.map((cat) => {
      return cat.items.map((item) => {
        if (item.itemUUID === itemUUID) {
          item.availability = availability;
        }
        return item;
      });
    });
  },
  reset: () => {
    set({
      menus: [],
      error: null,
      branch: null,
      loading: false,
      menuLoading: false,
      selectedMenu: null,
    });
  },
}));

export const useMenusStore = () => useStore(menusStore);

// start menu subscription when lookups are loaded
lookupsStore.subscribe(async (state) => {
  const menusState = menusStore.getState();

  if (!state.value) {
    menusState.reset();
  }
});
